import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";

import magnifiAPI from "../../services/api/magnifi";
import { organization } from "../schemas";

export const getOrganizationDetails = createAsyncThunk("magnifiUser/getOrganizationDetails", async (payload) => {
  try {
    const response = await magnifiAPI.getOrganizationDetails({ payload });
    return {
      ...response.data,
      ...(response.data.status ? normalize(response.data.data.organizations, [organization]) : {}),
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getBrightCoveToken = createAsyncThunk("magnifiUser/getBrightCoveToken", async (payload) => {
  try {
    const response = await magnifiAPI.getBrightCoveToken(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const editOrganization = createAsyncThunk("magnifiUser/editOrganization", async (payload) => {
  try {
    const response = await magnifiAPI.editOrganization(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const editWorkspace = createAsyncThunk("magnifiUser/editWorkspace", async (payload) => {
  try {
    const response = await magnifiAPI.editWorkspace(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getWorkspaceDetails = createAsyncThunk("magnifiUser/getWorkspaceDetails", async (payload) => {
  try {
    const response = await magnifiAPI.getWorkspaceDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getOrganizationWorkspaces = createAsyncThunk("magnifiUser/getOrganizationWorkspaces", async (payload) => {
  try {
    const response = await magnifiAPI.getOrganizationWorkspaces(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getAllOrganizationDetails = createAsyncThunk("magnifiUser/getAllOrganizationDetails", async (payload) => {
  try {
    const response = await magnifiAPI.getAllOrganizationDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getOrganizationUsers = createAsyncThunk("magnifiUser/getOrganizationUsers", async (payload) => {
  try {
    const response = await magnifiAPI.getOrganizationUsers(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getOrganizationAssignableUsers = createAsyncThunk(
  "magnifiUser/getOrganizationAssignableUsers",
  async (payload) => {
    try {
      const response = await magnifiAPI.getOrganizationAssignableUsers(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error.response.data;
    }
  },
);

export const assignOrganizationUser = createAsyncThunk("magnifiUser/assignOrganizationUser", async (payload) => {
  try {
    const response = await magnifiAPI.assignOrganizationUser(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response.data;
  }
});

export const createOrganizationUser = createAsyncThunk(
  "magnifiUser/createOrganizationUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await magnifiAPI.createOrganizationUser(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateOrganizationMember = createAsyncThunk("magnifiUser/updateOrganizationMember", async (payload) => {
  try {
    const response = await magnifiAPI.updateOrganizationMember({ payload });
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getAllOrganizations = createAsyncThunk("magnifiUser/updateOrganizationMember", async () => {
  try {
    const response = await magnifiAPI.getAllOrganizations();
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getAllOrganizationWorkspaces = createAsyncThunk(
  "magnifiUser/updateOrganizationMember",
  async (payload) => {
    try {
      const response = await magnifiAPI.getAllOrganizationWorkspaces(payload);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const createOrganizationWorkspace = createAsyncThunk(
  "magnifiUser/createOrganizationWorkspace",
  async (payload) => {
    try {
      const response = await magnifiAPI.createOrganizationWorkspace(payload);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const exportOrganizationReportCSV = createAsyncThunk(
  "magnifiUser/exportOrganizationReportCSV",
  async (payload) => {
    try {
      const response = await magnifiAPI.exportOrganizationReportCSV(payload);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getMeOrganizations = createAsyncThunk("magnifiUser/getMeOrganizations", async (payload) => {
  try {
    const response = await magnifiAPI.getMeOrganizations(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
